import ReactPlayer from "react-player";

type VideoPlayerProps = {
    url: string
}

const CustomVideoPlayer = ({ url }: VideoPlayerProps) : JSX.Element => {

    const config = {
        file: {
            forceVideo: true  
        }
    };

    return (
      <ReactPlayer
        url={url}
        config={config}
        controls
        width={"100%"}
        height={"100%"}
      />
    );
  };

  export default CustomVideoPlayer;